/**
 * Footer: Klaviyo newsletter input placeholder sync.
 */

(function () {
  'use strict';

  function syncNewsletterInput(form) {
    const placeholder = form.dataset.emailPlaceholder || 'Email';
    const input = form.querySelector('input[type="email"]');

    if (!input || input.placeholder === placeholder) return;

    input.placeholder = placeholder;
  }

  function initNewsletterForm(form) {
    if (!form || form.dataset.newsletterPlaceholderInit === 'true') return;

    form.dataset.newsletterPlaceholderInit = 'true';
    syncNewsletterInput(form);

    const observer = new MutationObserver(function () {
      syncNewsletterInput(form);
    });

    observer.observe(form, { childList: true, subtree: true, attributes: true });
  }

  function initAll(container) {
    const root = container || document;
    root.querySelectorAll('.footer__newsletter-form').forEach(initNewsletterForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
